import "core-js/modules/es.array.slice.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import BookSectionHeader from '@/components/renewal/book/book-section-header.vue';
import Icon from '@/components/renewal/common/icon.vue';
import { useTelemetry } from '@/plugins/telemetry';
import NO_IMAGE from '@/assets/noimage.png';
import ViewerLink from '@/components/viewer-link.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'book-section',
  props: {
    loading: {
      type: Boolean
    },
    title: null,
    books: null,
    href: null
  },
  setup: function setup(__props) {
    var carousel = ref(null);
    var page = ref(0);
    var carouselWidth = ref(0);
    var route = useRoute();
    var telemetry = useTelemetry();
    var noImage = NO_IMAGE;
    var handleImageError = function handleImageError(e) {
      var target = e.target;
      target.src = noImage;
    };
    var onResize = function onResize() {
      if (carousel.value != null) {
        carouselWidth.value = carousel.value.$el.clientWidth;
      }
    };
    var pages = function pages(books) {
      // 左右のボタン幅それぞれ 36px を引いた幅を 1 冊あたりの幅 150px で割る。最低 1 冊は表示する
      var pageSize = Math.max(Math.floor((carouselWidth.value - 36 * 2) / 150), 1);
      var pages = [];
      for (var i = 0; i < books.length; i += pageSize) {
        var docs = books.slice(i, i + pageSize);
        pages.push(docs);
      }
      return pages;
    };
    var carouselChangeHandler = function carouselChangeHandler() {
      telemetry.sendClickTelemetry({
        button: 'recently-added-document-carousel__change'
      }, route);
    };
    onMounted(function () {
      nextTick(onResize);
    });
    return {
      __sfc: true,
      carousel: carousel,
      page: page,
      carouselWidth: carouselWidth,
      route: route,
      telemetry: telemetry,
      noImage: noImage,
      handleImageError: handleImageError,
      onResize: onResize,
      pages: pages,
      carouselChangeHandler: carouselChangeHandler,
      BookSectionHeader: BookSectionHeader,
      Icon: Icon,
      ViewerLink: ViewerLink
    };
  }
});